export enum ConfigurationDomain {
  Ordering = 'ordering',
  Pricing = 'pricing',
}

export enum TableName {
  OrderEntry = 'order_entry_table',
  OrderEntryMobileCards = 'order_entry_mobile_cards',
  PricingAgent = 'pricing_agent_table',
  PricingBookmarks = 'pricing_bookmarks_table',
  PricingCustomerDetail = 'pricing_customer_detail_table',
  PricingCustomerList = 'pricing_customer_list_table',
  PricingItem = 'pricing_management_item_table',
  PricingManagement = 'pricing_management_table',
  PricingReview = 'pricing_management_review_table',
}
